import React from "react";
import { AlertTriangle, Flame, Moon, TrendingDown, Grid3X3, ChevronRight } from "lucide-react";

const META = {
  idle: { icon: Moon, tone: "border-amber-200 bg-amber-50 text-amber-800", chip: "Gone quiet" },
  never: { icon: Moon, tone: "border-slate-200 bg-slate-50 text-slate-700", chip: "Not started" },
  slipping: { icon: TrendingDown, tone: "border-red-200 bg-red-50 text-red-800", chip: "Slipping" },
  fire: { icon: Flame, tone: "border-emerald-200 bg-emerald-50 text-emerald-800", chip: "On fire" },
  skill: { icon: Grid3X3, tone: "border-cyan-200 bg-cyan-50 text-cyan-800", chip: "Team skill" },
};

export function AttentionList({ items, onOpenRep }) {
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white shadow-[0_4px_20px_-4px_rgba(15,23,42,0.06)] p-5 h-full" data-testid="attention-list">
      <h2 className="text-lg font-bold tracking-tight text-slate-900 flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-500" /> Needs attention</h2>
      <p className="text-xs text-slate-500 mt-1">Where five minutes of your time moves the needle this week.</p>
      {items.length === 0 ? (
        <p className="mt-4 text-sm text-emerald-700 font-semibold" data-testid="attention-empty">All quiet — everyone practised recently and scores are holding.</p>
      ) : (
        <ul className="mt-4 space-y-2">
          {items.map((a, i) => {
            const m = META[a.type] || META.idle;
            return (
              <li key={i}>
                <button onClick={() => a.rep_id && onOpenRep(a.rep_id)} disabled={!a.rep_id}
                  className={`w-full text-left flex items-center gap-3 rounded-2xl border p-3 transition-transform ${m.tone} ${a.rep_id ? "hover:-translate-y-0.5" : "cursor-default"}`} data-testid={`attention-${a.type}-${i}`}>
                  <m.icon className="w-4 h-4 shrink-0" />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-bold truncate">{a.name} <span className="ml-1 text-[10px] font-bold uppercase tracking-wider opacity-70">{m.chip}</span></div>
                    <div className="text-xs opacity-90 truncate">{a.text}</div>
                  </div>
                  {a.rep_id && <ChevronRight className="w-4 h-4 shrink-0 opacity-60" />}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
